<template>
  <form @submit.prevent="handlesubmit">
    <h2>Create New PlayList!</h2>
    <input type="text" name="" id="" placeholder="Playlist Name:" v-model="playlist">
    <textarea cols="30" rows="10" placeholder="Description" v-model="description"></textarea>
    <label for="avatar">Choose a playlist picture:</label>
    <input type="file" id="avatar" name="avatar" accept="image/png, image/jpeg" @change="handleFileChange"/>
    <div v-if="fileError" class="error">{{ fileError }}</div>
    <button v-if="!isPending">Add Playlist</button>
    <div v-else class="spinners">
      <loading />
    </div>
  </form>
</template>

<script>

import {ref} from 'vue'
import useStorage from '../../composable/useStorage'
import useCollection from "@/composable/useCollection";
import getUser from "@/composable/getUser";
import { timeStamp } from "@/firebase/config";
import { useRouter } from "vue-router";

import loading from "@/components/loading.vue";

export default {
  components: {
    loading,
  },
  setup() {

    const { url, filePath, uploadImage } = useStorage()

    const router = useRouter()

    const {addDoc, error} = useCollection('playlist')
    const { user } = getUser()

    const playlist = ref('')
    const description = ref('')
    const file = ref(null)
    const fileError = ref(null)
    const isPending = ref(false)

    const handlesubmit = async () =>{
      if(fileError){
        isPending.value = true
        console.log(playlist.value, description.value, file.value)
        await uploadImage(file.value)
        const res = await addDoc({
          title: playlist.value,
          description: description.value,
          userId: user.value.uid,
          userName: user.value.displayName,
          coverUrl: url.value,
          filePath: filePath.value,
          songs: [],
          createdAt: timeStamp()
        })

        if(!error.value){
          console.log('Malumot Muoffaqqiyatli Qo\'shildi!')
          isPending.value = false
          router.push({name: 'playlistsDetails', params: { id: res.id }})
        }

      }
    }
    const types = ['image/png', 'image/jpeg']

    const handleFileChange = (e) => {
      const selected = e.target.files[0]
      console.log(selected.type)
      if(selected && types.includes(selected.type)){
        file.value = selected
      } else {
        fileError.value = 'Please choose another file please!'
        file.value = null
      }
    }

    return{
      handlesubmit,
      description,
      playlist,
      handleFileChange,
      fileError,
      isPending
    }
  }
}

</script>

<style>

</style>